import React from 'react';
import { withStyles} from '@material-ui/core/styles';

import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import TitleCard from './cards/TitleCard';
import TypeCard from './cards/TypeCard';
import FolderCard from './cards/FolderCard';
import ChipCard from './cards/ChipCard';
import ParamTableCard from './cards/ParamTableCard';
import HTMLCard from './cards/HTMLCard';


const styles = theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  container:{
    backgroundColor: theme.palette.background.default,
    borderRadius:14,
    padding: theme.spacing(2),
    maxHeight: "75%",
    overflow: "auto",
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    marginTop:"8px",
    color: theme.palette.text.secondary,
    elevation:10
  },
});

class VariableModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.findMapping = this.findMapping.bind(this);
    this.chipClick = this.chipClick.bind(this);
  };

  handleClose() {
    this.props.modalClose();
  };

  findMapping(name,type){
    let output = {};
    let searchType = type+'Data';
    if(typeof window.__GTM_DOCS__[searchType] !== 'undefined'){
      window.__GTM_DOCS__[searchType].forEach((tag)=>{
        if(tag[0].name === name){
          output = tag;
        }
      });
    }
    return output;
  }

  chipClick(data, type) {
      this.props.modalClose();
      this.props.chipClick(data,type);
  }

  render(){
    const { classes } = this.props;
    let htmlCode = '';

    if(typeof this.props.data.parameter !== 'undefined'){
      if(this.props.data.type === 'jsm'){
        htmlCode = <HTMLCard title="Custom Javascript Variable" html={this.props.data.parameter[0].value} lang="javascript" style={classes.paper} />;
      }else{
        this.props.data.parameter.forEach((param)=>{
            htmlCode = <ParamTableCard data={this.props.data.parameter} style={classes.paper} type={this.props.type}/>;
        })
      }
    }

    let parentData = this.findMapping(this.props.data.name, this.props.type);

    return (
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={this.props.modalState}
          onClose={this.handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={this.props.modalState} >
            <Container maxWidth="md" className={classes.container}>
                <Grid container spacing={2}>

                <TitleCard type={this.props.type} data={this.props.data}/>

                <Grid item xs={12} md={12} lg={6}>
                  <Paper className={classes.paper}>
                    <TypeCard data={this.props.data} style={classes.paper} type="Variable"/>
                    <FolderCard data={this.props.data} style={classes.paper} folderName={parentData[5]}/>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={12} lg={6} >
                  <Paper className={classes.paper}>
                    <ChipCard title="Tags" type="tag" data={parentData[1]} chipClick={this.chipClick} style={classes.paper} />
                    <ChipCard title="Triggers" type="triggers" data={parentData[2]} chipClick={this.chipClick} style={classes.paper} />
                    <ChipCard title="Vars Referenced" type="variables" data={parentData[3]} chipClick={this.chipClick} style={classes.paper} />
                    <ChipCard title="Vars in Params" type="variables" data={parentData[4]} chipClick={this.chipClick} style={classes.paper} />
                  </Paper>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  {htmlCode}
                </Grid>

              </Grid>
            </Container>
          </Fade>
        </Modal>
      </div>
    );
  }
}

VariableModal.propTypes = {
  classes: PropTypes.object.isRequired,
};



export default withStyles(styles)(VariableModal);
